import { connectDependentSelect2Fields, setCookie, removeCookie } from "../utils/fn";

export default () => {
  var $widgets = $('.m1-find-vehicle-eu:not(".initialized"):visible'),
    $small = $('.m1-find-vehicle-eu-wrapper'),
    $widgetTitle = $('.m1-find-vehicle-eu .m1-find-vehicle-wrapper');

  // $widgets.on('click', '.m1-find-vehicle-us_toggle-button', function() {
  //   var $btn = $(this),
  //     $widget = $('.m1-find-vehicle-eu'),
  //     isCollapsed = $widget.hasClass('collapsed'),
  //     $small = $widget.find('.m1-find-vehicle-eu-wrapper');

  //   // $small.stop(true);

  //   if (isCollapsed) {
  //     $widget.removeClass('collapsed');
  //     $small.slideDown(300);

  //     $(window).trigger('find-vehicle-before-expand');

  //     $.cookie('find_vehicle_expanded', 1, { expires: 365, path: '/' });
  //   } else {
  //     $widget.addClass('collapsed');
  //     $small.slideUp(300);
  //     $.removeCookie('find_vehicle_expanded');
  //   }
  // });
  
  $widgetTitle.on('click', $widgetTitle, function() {
    if ($(window).width() < 768) {
      var $btn = $('.m1-find-vehicle-us_toggle-button'),
        $widget = $('.m1-find-vehicle-eu'),
        isCollapsed = $widget.hasClass('collapsed'),
        $small = $widget.find('.m1-find-vehicle-eu-wrapper');

      // $small.stop(true);

      if (isCollapsed) {
        $widget.removeClass('collapsed');
        $small.slideDown(300);

        $(window).trigger('find-vehicle-before-expand');

        setCookie('find_vehicle_expanded', 1, 365);
      } else {
        $widget.addClass('collapsed');
        $small.slideUp(300);
        removeCookie('find_vehicle_expanded');
      }
    }
  });

  function loadFormFind($widgets, $small) {
    $widgets.each(function(index, widget) {
      var $widget = $(widget),
        $sections = $widgets.find('section'),
        isCollapsed = $widget.hasClass('collapsed');

      if (isCollapsed) {
        $small.hide();
      }

      $sections.each(function(index, section) {
        var $section = $(section),
          $form = $section.find('form'),
          formData = $form.data(),
          $cars_form_make = $form.find('.cars_form_make'),
          $cars_form_model = $form.find('.cars_form_model'),
          $cars_form_submit = $form.find('.cars_form_submit'),
          href = '';

        $form.on('submit', function(event) {
          event.preventDefault();

          var data = $form.serializeArray();

          gtmDataLayer.push({
            event: 'findVehicleSubmit',
          });

          if (!data && formData.cseType === 'drivek') {
            window.location.href = formData.drivekUrl;
            return;
          }

          var emptyData = [];

          data.forEach(element => {
            if (element.value != ' ') {
              emptyData.push(element.value);
              return false;
            }
          });

          href = '/' + emptyData.join('/') + '/';

          window.location.href = href;
        });

        connectDependentSelect2Fields(
          $cars_form_make,
          $cars_form_model,
          'make_id',
          $cars_form_submit
        );

        $.fn.select2.defaults.set('language', {
          errorLoading: function() {
            return i18n.no_results;
          },
          loadingMore: function() {
            return i18n.loading;
          },
          noResults: function() {
            return i18n.no_results;
          },
          searching: function() {
            return i18n.loading;
          },
        });

        $cars_form_model
          .select2({
            placeholder: i18n.select_model,
          })
          .on('select2:open', function(event) {
            setTimeout(function() {
              $('.select2-search input').blur();
            }, 1);
          });
      });

      $widget.addClass('initialized');
    });
  }

  loadFormFind($widgets, $small);

  $(window).on('resize', function() {
    const readyStatus = $('.m1-find-vehicle-eu:not(".initialized")').is(
      ':visible'
    );
    $widgets = $('.m1-find-vehicle-eu:not(".initialized"):visible');

    if (readyStatus) {
      loadFormFind($widgets, $small);
    }
  });
};
